export default __webpack_public_path__ + "static/media/INDEXX-CRYPTO.8042d8ab.gif";